import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import { useI18n } from '@oneaudi/i18n-context';
import { Text, TextLink, Headline, TextButton } from '@oneaudi/unified-web-components';
import { getPaymentValue, resolveDisclaimer } from '../../../../utils/crs-helper';
import { useServicesContext } from '../../../../../context';
import { FinanceModalRethink } from '../financeModalRethink/FinanceModalRethink';
import { AlertModal } from '../styles/FinanceRethink.styles';
import { trackLayerOpen, trackLayerClose, trackCTAClick, } from '../../../../../components/ctaButtons/tracking';
import { readFinance } from '../../../../utils/sessionStorage';
import { useFinance } from '../FinanceContext';
export const SharedChangeRateLink = ({ vehicle }) => {
    var _a;
    const layerManager = useServicesContext().getAdditionalService('gfa:layer-manager');
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const { getConfiguration } = useServicesContext();
    const currencyPattern = React.useMemo(() => { var _a; return (_a = getConfiguration()) === null || _a === void 0 ? void 0 : _a.currencyPattern; }, [getConfiguration]);
    const i18n = {
        rateAlternativeText: useI18n({ id: 'nemo.ui.sc.details.finance.rate.alternativeText' }),
        disclaimerText: useI18n({
            id: 'nemo.ui.sc.details.finance.disclaimer.text',
            defaultMessage: '',
        }),
        rateText1: `${useI18n({
            id: 'nemo.ui.sc.details.finance.rate.text1',
            defaultMessage: '',
        })} `,
        rateText2: `${useI18n({
            id: 'nemo.ui.sc.details.finance.rate.text2',
            defaultMessage: '',
        })} `,
        rateChange: useI18n({
            id: 'nemo.ui.sc.details.finance.rate.button.change',
            defaultMessage: 'Change rate',
        }),
        errorHeadline: useI18n({
            id: 'nemo.ui.sc.details.finance.error.headline',
            defaultMessage: '',
        }),
        errorMessage: useI18n({
            id: 'nemo.ui.sc.details.finance.error.text',
            defaultMessage: '',
        }),
        errorCloseButton: useI18n({
            id: 'nemo.ui.sc.details.finance.error.button.close',
            defaultMessage: '',
        }),
        dialogSuccessAriaLabel: useI18n({
            id: 'nemo.ui.sc.details.finance.layer.success.aria.label',
            defaultMessage: '',
        }),
        dialogInnerSuccessAriaLabel: useI18n({
            id: 'nemo.ui.sc.details.finance.inner.layer.success.aria.label',
            defaultMessage: '',
        }),
        dialogErrorAriaLabel: useI18n({
            id: 'nemo.ui.sc.details.finance.layer.error.aria.label',
            defaultMessage: '',
        }),
        dialogInnerErrorAriaLabel: useI18n({
            id: 'nemo.ui.sc.details.finance.inner.layer.error.aria.label',
            defaultMessage: '',
        }),
    };
    const { dynamicFinance, updateDynamicFinance } = (_a = useFinance()) !== null && _a !== void 0 ? _a : {};
    const errorInWebcalcRef = React.useRef(false);
    const [focusLayerNode, setFocusLayerNode] = React.useState();
    const [focusLayer, setFocusLayer] = React.useState();
    const focusLayerRef = React.useCallback((node) => {
        setFocusLayerNode(node);
    }, [setFocusLayerNode]);
    const openFocusLayer = () => {
        const layer = layerManager.openFocusLayer(() => React.createElement("div", { ref: focusLayerRef }), {
            withFefa: true,
            primaryAriaLabel: i18n.dialogSuccessAriaLabel,
            secondaryAriaLabel: i18n.dialogInnerSuccessAriaLabel,
        }, {
            size: "A",
            userCloseable: true,
            onClose: () => {
                trackLayerClose(trackingService);
            },
        });
        setFocusLayer(layer);
    };
    const fetchUpdatedValuesFromStore = () => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!vehicleBasic) {
            return;
        }
        const vehicleId = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.id;
        const financeDataFromStore = readFinance(vehicleBasic.type);
        const financing = (_a = financeDataFromStore === null || financeDataFromStore === void 0 ? void 0 : financeDataFromStore.financing) === null || _a === void 0 ? void 0 : _a[vehicleId];
        if (financing === null || financing === void 0 ? void 0 : financing.financeResponseData) {
            const { rate, rateText, calculationDisclaimer } = dynamicFinance !== null && dynamicFinance !== void 0 ? dynamicFinance : {};
            const newDynamicFinance = dynamicFinance;
            const { campaign, productParameter, financeResponseData } = financing !== null && financing !== void 0 ? financing : {};
            const getPaymentDescription = (parameters) => {
                if ((campaign === null || campaign === void 0 ? void 0 : campaign.filterText) &&
                    (!Object.keys(productParameter).length ||
                        (productParameter && productParameter['@CampaignID']))) {
                    return campaign.filterText;
                }
                if (typeof (parameters === null || parameters === void 0 ? void 0 : parameters.Description) === 'string') {
                    return parameters.Description;
                }
                if (parameters === null || parameters === void 0 ? void 0 : parameters.Description['#text']) {
                    return parameters.Description['#text'];
                }
                return '';
            };
            if ((_b = financeResponseData === null || financeResponseData === void 0 ? void 0 : financeResponseData.Response) === null || _b === void 0 ? void 0 : _b.Parameters) {
                if ((_d = (_c = financeResponseData === null || financeResponseData === void 0 ? void 0 : financeResponseData.Response) === null || _c === void 0 ? void 0 : _c.Parameters) === null || _d === void 0 ? void 0 : _d.Group) {
                    const group = (_f = (_e = financeResponseData === null || financeResponseData === void 0 ? void 0 : financeResponseData.Response) === null || _e === void 0 ? void 0 : _e.Parameters) === null || _f === void 0 ? void 0 : _f.Group;
                    const newRate = Array.isArray(group)
                        ? getPaymentValue(group[0].Parameter, currencyPattern)
                        : getPaymentValue(group.Parameter, currencyPattern);
                    if (newRate !== rate) {
                        newDynamicFinance.rate = newRate;
                    }
                }
                const newRateText = getPaymentDescription((_g = financeResponseData === null || financeResponseData === void 0 ? void 0 : financeResponseData.Response) === null || _g === void 0 ? void 0 : _g.Parameters);
                if (newRateText !== rateText) {
                    newDynamicFinance.rateText = newRateText;
                }
                const newCalculationDisclaimer = resolveDisclaimer(financeResponseData === null || financeResponseData === void 0 ? void 0 : financeResponseData.Response, 'CalculationDisclaimer', false);
                if (newCalculationDisclaimer !== calculationDisclaimer) {
                    newDynamicFinance.calculationDisclaimer = newCalculationDisclaimer;
                }
            }
            updateDynamicFinance(newDynamicFinance);
        }
    };
    const closeFocusLayer = () => {
        fetchUpdatedValuesFromStore();
        focusLayer.close();
    };
    const [error, setError] = React.useState('');
    const [alertLayerNode, setAlertLayerNode] = React.useState();
    const [alertLayer, setAlertLayer] = React.useState();
    const alertLayerRef = React.useCallback((node) => {
        setAlertLayerNode(node);
    }, [setAlertLayerNode]);
    const openAlertLayer = () => {
        const layer = layerManager.openAlert(() => React.createElement("div", { ref: alertLayerRef }), {
            primaryAriaLabel: i18n.dialogErrorAriaLabel,
            secondaryAriaLabel: i18n.dialogInnerErrorAriaLabel,
        }, {
            userCloseable: true,
            id: 'VTP_dynamic_financing_error',
            onClose: () => {
                setError('');
            },
        });
        setAlertLayer(layer);
    };
    const closeAlertLayer = () => {
        alertLayer.close();
    };
    React.useEffect(() => {
        if (error) {
            openAlertLayer();
        }
    }, [error]);
    const onError = (errorMessage) => {
        console.error(errorMessage);
        closeFocusLayer();
        if ((!alertLayer || alertLayer.isClosed) && !error) {
            setTimeout(() => {
                setError(errorMessage);
            }, 100);
        }
    };
    const vehicleBasic = vehicle.basic;
    const { financing } = vehicleBasic;
    const trackLayerLinkClick = (event, rateChangeLabel) => {
        trackCTAClick(trackingService, {
            label: event.target.id === 'change-rate-text' ? rateChangeLabel : '',
            method: '',
            target: 'same-window',
            type: event.target.id === 'change-rate-text' ? 'financeOptions' : 'financeInfo',
            url: '',
            variant: '',
        });
    };
    const setCalculationError = (calcError) => {
        errorInWebcalcRef.current = calcError;
    };
    const financeData = useMemo(() => {
        return fetchStoredFinanceData(vehicle);
    }, [dynamicFinance, vehicle]);
    if (!financeData) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null, financing && financeData && (React.createElement(React.Fragment, null,
            React.createElement(TextLink, { size: "sm", "data-testid": "change-rate-button", onClick: (event) => {
                    openFocusLayer();
                    trackLayerLinkClick(event, i18n.rateChange);
                    trackLayerOpen(trackingService, 'vtp finance', 'vtp finance layer');
                }, variant: "standalone" }, i18n.rateChange)))),
        focusLayerNode &&
            ReactDOM.createPortal(React.createElement(FinanceModalRethink, { fullVehicle: vehicle, onClose: closeFocusLayer, onError: onError, financeData: financeData, setCalculationError: setCalculationError }), focusLayerNode),
        alertLayerNode &&
            ReactDOM.createPortal(React.createElement(AlertModal, null,
                React.createElement(Headline, { variant: {
                        order: '4',
                        type: 'headline',
                        weight: 'normal',
                    }, tag: "h2" }, i18n.errorHeadline),
                React.createElement(Text, { tag: "span", variant: { type: 'copy', order: '2', style: 'normal' } }, i18n.errorMessage ? i18n.errorMessage : error),
                React.createElement(TextButton, { variant: "primary", onClick: closeAlertLayer }, i18n.errorCloseButton)), alertLayerNode)));
};
const fetchStoredFinanceData = (vehicle) => {
    var _a, _b, _c;
    const vehicleId = (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.basic) === null || _a === void 0 ? void 0 : _a.id;
    if (!vehicleId)
        return null;
    const vehicleFinanceData = (_c = (_b = readFinance(vehicle.basic.type)) === null || _b === void 0 ? void 0 : _b.financing) === null || _c === void 0 ? void 0 : _c[vehicleId];
    if (!(vehicleFinanceData === null || vehicleFinanceData === void 0 ? void 0 : vehicleFinanceData.defaultProductData) || !(vehicleFinanceData === null || vehicleFinanceData === void 0 ? void 0 : vehicleFinanceData.defaultResponse)) {
        return null;
    }
    return vehicleFinanceData;
};
